import { useQuery } from "react-query";
import { searchOfficeSettings } from "../../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useGetAllSalesOperations = () => {
  return useQuery(
     ["GetSalesOpsReport",{  }],
    searchOfficeSettings,
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllSalesOperations;
